import React, { useState, useEffect, useMemo, useLayoutEffect } from "react";

import FilterForm from "app/Components/FilterForm/FilterForm";
import {
  useArea,
  useCategory,
  useContractorDropdown,
  useContractorPersonDropdown,
  useEmployeeDropdown,
} from "app/_helpers/hooks";
import { getAllActivity } from "app/_services/_globalConfiguration/Activity/ActivityService";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
//import { UserService } from "app/_services/UserService/UserService";
//import { LOGGED_IN_USER_SITE_ID } from "../../IncidentManagement/Helper";
import { userDropdownLabel } from "app/_helpers/helper";
import moment from "moment";
import { LOGGED_IN_USER_SITE_ID } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
import { UserService } from "app/_services/UserService/UserService";
//import { TRAINEE_TYPE, trainingStatusFilterFields } from "../../CONSTANTS";
import { formAFilterFields } from "./FormAManagement.data";
import { TRAINEE_TYPE } from "../TrainingManagement/CONSTANTS";

export default function FormAFilters({ form, onChange, onReset, setForm }) {
  const [state, setState] = useState({
    sites: [],
  });

  const [employees, employeesOption] = useEmployeeDropdown();
  const [contractorPersons, contractorPersonsOption] = useContractorPersonDropdown();
  const [contractors, contractorOption] = useContractorDropdown();

  const [nameList, setNameList] = useState([]);

  useEffect(() => {
    setNameList(
      form?.staffTypeName === TRAINEE_TYPE.employee
        ? [...employeesOption]
        : form?.staffTypeName === TRAINEE_TYPE.contractorPerson
        ? [...contractorPersonsOption]
        : [...employeesOption, ...contractorPersonsOption]
    );
  }, [contractorPersonsOption, employeesOption, form?.staffTypeName]);

  useEffect(() => {
    getAllSites("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setState((prev) => ({
        ...prev,
        //initialActivity: response?.data,
        sites: response.data.map((row) => ({ label: row.name, value: row.id })),
      }));
    });
  }, []);

  const fields = useMemo(
    () =>
      formAFilterFields.map((f) => {
        const field = { ...f };

        switch (field.name) {
          case "id":
            field.options = nameList;
            break;
          case "currentWorkLocation":
            field.options = state.sites;
            break;
          case "contractorId":
            field.options = contractors.map((d) => ({
              label: d.contractorLegalEntity,
              value: d.id,
            }));
            break;
          default:
            break;
        }

        return field;
      }),
    [nameList, state.sites, contractors]
  );

  return (
    <div className="pb-4">
      <FilterForm fields={fields} form={form} onChange={onChange} onReset={onReset} />
    </div>
  );
}
